import { Joi } from 'celebrate'

export const ProductSchema = Joi.object()
  .required()
  .keys({
    id: Joi.number().required(),
    term_id: Joi.number().allow(null).optional(),
    name: Joi.string().required(),
    description: Joi.string().required(),
    vertical: Joi.string().required(),
    purpose: Joi.string().required(),
    dimensions: Joi.object()
      .keys({
        type: Joi.string().allow(null).optional(),
        size: Joi.string().allow(null).optional(),
        points_band: Joi.string().allow(null).optional(),
        is_interest_only: Joi.boolean().allow(null).optional(),
        is_fha: Joi.boolean().allow(null).optional(),
        is_va: Joi.boolean().allow(null).optional()
      })
      .required(),
    term: Joi.object()
      .keys({
        id: Joi.number().required(),
        name: Joi.string().required(),
        fixed_months: Joi.number().required(),
        variable_months: Joi.number().required(),
        evaluation_period: Joi.number().required()
      })
      .allow(null)
      .optional()
  })
  .description('This is what a Product looks like')
  .meta({ className: 'Product' })

const cardsSchema = {
  card_name: Joi.string().allow(null).optional(),
  card_class: Joi.string().allow(null).optional(),
  card_type: Joi.string().allow(null).optional(),
  purchase_apr: Joi.string().allow(null).optional(),
  purchase_rate: Joi.number().precision(3).allow(null).optional(),
  purchase_index_rate: Joi.number().precision(3).allow(null).optional(),
  cash_advance_apr: Joi.string().allow(null).optional(),
  cash_advance_rate: Joi.number().precision(3).allow(null).optional(),
  cash_advance_index_rate: Joi.number().precision(3).allow(null).optional(),
  internal_card_name: Joi.string().allow(null).optional()
}

const RateAttributesSchema = Joi.object().keys({
  apr: Joi.number().precision(3).allow(null).optional(),
  rate: Joi.number().precision(3).allow(null).optional(),
  loan_conditions: Joi.string().allow(null).optional(),
  min_loan_amount: Joi.any().allow(null).optional(),
  upfront_fees: Joi.number().precision(2).allow(null).optional(),
  discount_points: Joi.number().precision(3).allow(null).optional(),
  origination_points: Joi.number().precision(3).allow(null).optional(),
  lock_period: Joi.number().integer().allow(null).optional(),
  margin: Joi.number().precision(3).allow(null).optional(),
  first_cap: Joi.number().precision(3).allow(null).optional(),
  additional_cap: Joi.number().precision(3).allow(null).optional(),
  lifetime_cap: Joi.number().precision(3).allow(null).optional(),
  intro_rate: Joi.number().precision(3).allow(null).optional(),
  index_rate: Joi.number().precision(3).allow(null).optional(),
  cash_advance: Joi.number().integer().allow(null).optional(),
  loan_min: Joi.number().allow(null).optional(),
  svy_date: Joi.date().allow(null).optional(),
  ...cardsSchema
})

export const RateSchema = Joi.object()
  .required()
  .keys({
    id: Joi.number().allow(null).optional(),
    rate_set_id: Joi.number().required(),
    product_id: Joi.number().required(),
    paired_rate_id: Joi.number().allow(null).optional(),
    index_id: Joi.number().allow(null).optional(),
    rate_attributes: RateAttributesSchema,
    previous_rate_attributes: RateAttributesSchema,
    notes: Joi.string().allow(null, '').optional(),
    product: ProductSchema.optional(),
    created_at: Joi.date(),
    updated_at: Joi.date(),
    deleted_at: Joi.date().allow(null).optional()
  })
  .description('This is what a Rate looks like')
  .meta({ className: 'Rate' })
